import app from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import "firebase/functions";

const firebaseConfig = {
  apiKey: "AIzaSyBachpgsyrLmjDOw3RQIM8LjmU9FVy9Tzg",
  authDomain: "suzuki-compare-module.firebaseapp.com",
  projectId: "suzuki-compare-module",
  storageBucket: "suzuki-compare-module.appspot.com",
  messagingSenderId: "105034129954",
  appId: "1:105034129954:web:7a85fb12070d256337a07b",
};

class Firebase {
  constructor() {
    app.initializeApp(firebaseConfig);

    this.auth = app.auth();
    this.db = app.firestore();
    this.functions = app.functions();
  }
}

export default Firebase;
